import script from "./ml-tabs.vue?vue&type=script&setup=true&lang=js"
export * from "./ml-tabs.vue?vue&type=script&setup=true&lang=js"

import "./ml-tabs.vue?vue&type=style&index=0&id=db8348fc&lang=scss"

const __exports__ = script;

export default __exports__